import { useEffect, useState, useRef } from "react";
import Table from "../components/Table";
import Modal from "../components/Modal";
import Form from "../components/Form";
import FotoUpload from "../components/FotoUpload";
import ModalAsignar from "../components/ModalAsignar";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

const ESTADO_INICIAL = {
  id: null, numero_celular: '', cuenta_google: '', marca: '', modelo: '',
  imei: '', plan: '239 CON TODO NEGOCIOS', estado: 'Disponible', costo: '', accesorios: '',
  sucursal_id: '', area_id: '', foto_file: null, foto_preview: null
};

export default function CelularesScreen({ currentUser, token }) {
  const [celulares, setCelulares] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [areas, setAreas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showBajas, setShowBajas] = useState(false);
  const [celularForm, setCelularForm] = useState(ESTADO_INICIAL);
  const [celularAsignar, setCelularAsignar] = useState(null);
  const [usuarioId, setUsuarioId] = useState('');
  const [celularDetalle, setCelularDetalle] = useState(null);
  const [asignaciones, setAsignaciones] = useState([]);
  const [asignSeleccionada, setAsignSeleccionada] = useState(null);
  const fileRef = useRef();
  const [modal, setModal] = useState({ visible: false, titulo: '', mensaje: '', tipo: 'info', onConfirm: null });

  const isAdmin = currentUser?.rol === 'admin' || currentUser?.rol === 'celular';
  const showModal = (tipo, titulo, mensaje, onConfirm = null) =>
    setModal({ visible: true, tipo, titulo, mensaje, onConfirm });
  const set = (campo) => (v) => setCelularForm(f => ({ ...f, [campo]: v }));
  const fotoUrl = (url) => url ? `${API_URL.replace('/api', '')}${url}` : null;

  const cargar = async () => {
    setLoading(true);
    try {
      const [resC, resS, resA, resU] = await Promise.all([
        fetch(`${API_URL}/celulares`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API_URL}/sucursales`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API_URL}/areas`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API_URL}/usuarios`, { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      setCelulares(resC.ok ? await resC.json().catch(() => []) : []);
      setSucursales(resS.ok ? await resS.json().catch(() => []) : []);
      setAreas(resA.ok ? await resA.json().catch(() => []) : []);
      setUsuarios(resU.ok ? await resU.json().catch(() => []) : []);
    } catch {
      showModal('error', 'Error', 'No se pudieron cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const cargarBajas = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/celulares/bajas`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json().catch(() => []);
      setCelulares(Array.isArray(data) ? data : []);
    } catch {
      showModal('error', 'Error', 'No se pudieron cargar las bajas');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => { setCelularForm(ESTADO_INICIAL); setShowForm(true); };
  const cerrarForm = () => { setShowForm(false); setCelularForm(ESTADO_INICIAL); };

  const abrirAsignar = (row) => {
    setCelularAsignar(row);
    setUsuarioId('');
  };
  const cerrarAsignar = () => {
    setCelularAsignar(null);
    setUsuarioId('');
  };

  const abrirEditar = (row) => {
    setCelularForm({
      ...ESTADO_INICIAL, ...row, foto_file: null, foto_preview: fotoUrl(row.foto_url),
      fecha_compra: row.fecha_compra ? row.fecha_compra.split('T')[0] : ''
    });
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubirFoto = async (id, archivo) => {
    const formData = new FormData();
    formData.append('foto', archivo);
    await fetch(`${API_URL}/celulares/${id}/foto`, {
      method: 'PUT', headers: { Authorization: `Bearer ${token}` }, body: formData
    });
  };

  const handleGuardar = async (e) => {
    e.preventDefault();
    try {
      const { foto_file, foto_preview, ...resto } = celularForm;
      const esEdicion = !!celularForm.id;
      const res = await fetch(
        esEdicion ? `${API_URL}/celulares/${celularForm.id}` : `${API_URL}/celulares`,
        {
          method: esEdicion ? 'PUT' : 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify(resto)
        }
      );
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message);
      if (foto_file) await handleSubirFoto(data.id ?? celularForm.id, foto_file);
      cerrarForm();
      cargar();
      showModal('success', 'Listo', esEdicion ? 'Celular actualizado' : 'Celular creado');
    } catch (err) {
      showModal('error', 'Error', err.message);
    }
  };

  const handleAsignar = async (e) => {
    e.preventDefault();
    try {
      console.log('Celular_id: ', celularAsignar.id);
      console.log('Usuario_id: ',usuarioId)
      const res = await fetch(`${API_URL}/celulares/asignar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ celular_id: celularAsignar.id, usuario_id: usuarioId })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message);
      cerrarAsignar();
      cargar();
      showModal('success', 'Listo', 'Celular asignado correctamente');
    } catch (err) {
      showModal('error', 'Error', err.message);
    }
  };

  const handleDesasignar = (row) => {
    showModal('confirm', '¿Desasignar celular?', `Se desasignará ${row.marca} ${row.modelo}`,
      async () => {
        try {
          const res = await fetch(`${API_URL}/celulares/desasignar`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ celular_id: row.id })
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data.message);
          cargar();
          showModal('success', 'Listo', 'Celular desasignado');
        } catch (err) {
          showModal('error', 'Error', err.message);
        }
      }
    );
  };

  const abrirDetalle = async (row) => {
    try {
      const res = await fetch(`${API_URL}/celulares/${row.id}/asignaciones`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json().catch(() => []);
      setAsignaciones(Array.isArray(data) ? data : []);
      setCelularDetalle(row);
    } catch {
      showModal('error', 'Error', 'No se pudieron cargar las asignaciones');
    }
  };

  const handleDescargar = async (asignacion) => {
    try {
      const res = await fetch(`${API_URL}/celulares/responsiva/${asignacion.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('No se pudo descargar');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `responsiva_celular_${asignacion.id}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      showModal('error', 'Error', err.message);
    }
  };

  const handleSubirFirmada = async (archivo) => {
    if (!archivo || !asignSeleccionada) return;
    const formData = new FormData();
    formData.append('responsiva', archivo);
    try {
      const res = await fetch(`${API_URL}/celulares/responsiva/${asignSeleccionada.id}/firmar`, {
        method: 'PUT', headers: { Authorization: `Bearer ${token}` }, body: formData
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message);
      setAsignSeleccionada(null);
      abrirDetalle(celularDetalle);
      showModal('success', 'Listo', 'Responsiva firmada subida');
    } catch (err) {
      showModal('error', 'Error', err.message);
    }
  };

  const formatFecha = (f) => {
    if (!f) return '—';
    if (typeof f === 'string' && f.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [y, m, d] = f.split('-'); return `${d}-${m}-${y}`;
    }
    const d = new Date(f);
    return `${String(d.getUTCDate()).padStart(2, '0')}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${d.getUTCFullYear()}`;
  };

  const coloresEstado = { 'Pendiente': '#007bff', 'Firmada': '#28a745', 'Cancelada': '#dc3545' };

  // ── Config tabla ──────────────────────────────────────────────────────
  const columnas = [
    {
      header: 'Foto', render: (row) => (
        <FotoUpload foto={fotoUrl(row.foto_url)} nombre={row.marca}
          onUpload={(archivo) => handleSubirFoto(row.id, archivo).then(cargar)} />
      )
    },
    { header: 'Marca', accessor: 'marca' },
    { header: 'Modelo', accessor: 'modelo' },
    { header: 'N° Serie', accessor: 'numero_serie' },
    { header: 'IMEI', accessor: 'imei' },
    { header: 'Estado', accessor: 'estado' },
    { header: 'Sucursal', render: (row) => sucursales.find(s => s.id === row.sucursal_id)?.nombre ?? '—' },
    { header: 'Área', render: (row) => areas.find(a => a.id === row.area_id)?.nombre ?? '—' },
    ...(isAdmin ? [{
      header: 'Acciones', render: (row) => (
        <>
          <button className="btn-edit" onClick={() => abrirEditar(row)}>Editar</button>
          <button className="btn-edit" style={{ background: '#17a2b8', color: 'white' }}
            onClick={() => abrirDetalle(row)}>Historial</button>
          {row.estado === 'Disponible' && (
            <button className="btn-edit" style={{ background: '#28a745', color: 'white' }}
              onClick={() => abrirAsignar(row)}>Asignar</button>
          )}
          {row.estado === 'Asignado' && (
            <button className="btn-delete"
              onClick={() => handleDesasignar(row)}>Desasignar</button>
          )}
        </>
      )
    }] : []),
  ];

  // ── Config form ───────────────────────────────────────────────────────
  const campos = [
    {
      fullRow: true, render: () => (
        <FotoUpload foto={celularForm.foto_preview} nombre={celularForm.marca} editable
          onUpload={(archivo) => setCelularForm(f => ({
            ...f, foto_file: archivo, foto_preview: URL.createObjectURL(archivo)
          }))} />
      )
    },
    { label: 'Marca', value: celularForm.marca, onChange: set('marca'), required: true, placeholder: 'Marca' },
    { label: 'Modelo', value: celularForm.modelo, onChange: set('modelo'), required: true, placeholder: 'Modelo' },
    { label: 'IMEI', value: celularForm.imei, onChange: set('imei'), required: true, placeholder: 'IMEI' },
    { label: 'Plan', value: celularForm.plan, onChange: set('plan'), required: true, placeholder: 'Plan' },
    { label: 'Número celular', value: celularForm.numero_celular, onChange: set('numero_celular'), required: true, placeholder: 'Número celular' },
    { label: 'Cuenta Google', value: celularForm.cuenta_google, onChange: set('cuenta_google'), placeholder: 'Cuenta Google (Opcional)' },
    { label: 'Costo', type: 'textarea', fullRow: true, value: celularForm.costo,onChange: set('costo'), placeholder: 'Costo (Opcional)'
    },
    {
      label: 'Estado', type: 'select', value: celularForm.estado, onChange: set('estado'),
      options: ['Disponible', 'Asignado', 'En reparación', 'Baja']
    },
    {
      label: 'Sucursal', type: 'select', value: celularForm.sucursal_id, onChange: set('sucursal_id'),
      options: [{ value: '', label: '-- Selecciona --' }, ...sucursales.map(s => ({ value: s.id, label: s.nombre }))]
    },
    {
      label: 'Área', type: 'select', value: celularForm.area_id, onChange: set('area_id'),
      options: [{ value: '', label: '-- Selecciona --' }, ...areas.map(a => ({
        value: a.id, label: `${sucursales.find(s => s.id === a.sucursal_id)?.nombre ?? '?'} - ${a.nombre}`
      }))]
    },
    {
      label: 'Accesorios', type: 'textarea', fullRow: true, value: celularForm.accesorios,
      onChange: set('accesorios'), placeholder: 'Accesorios incluidos (Opcional)'
    },
  ];

  if (loading) return <p>Cargando...</p>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ margin: 0 }}>Celulares</h2>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {!showBajas && isAdmin && (
            <button className="btn-secondary" onClick={showForm ? cerrarForm : abrirNuevo}>
              {showForm ? 'Cancelar' : '+ Nuevo Celular'}
            </button>
          )}
          {isAdmin && (
            <button className="btn-primary" onClick={() => {
              if (showBajas) { setShowBajas(false); cargar(); }
              else { setShowBajas(true); cerrarForm(); cargarBajas(); }
            }}>
              {showBajas ? 'Ver Celulares' : 'Ver Bajas'}
            </button>
          )}
        </div>
      </div>

      {showForm && (
        <Form campos={campos} onSubmit={handleGuardar} onCancel={cerrarForm}
          submitLabel={celularForm.id ? 'Actualizar Celular' : 'Crear Celular'} />
      )}

      <Table columnas={columnas} datos={celulares} mensajeVacio="Sin celulares registrados" />

      {/* Modal asignar */}
      <ModalAsignar item={celularAsignar} usuarios={usuarios} usuarioId={usuarioId}
        onChangeUsuario={setUsuarioId} onSubmit={handleAsignar}
        onClose={cerrarAsignar} />

      {/* Modal historial asignaciones */}
      {celularDetalle && (
        <div className="overlay" onClick={() => setCelularDetalle(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}
            style={{ width: 600, maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
            <h3 style={{ margin: 0, flexShrink: 0 }}>
              Asignaciones — {celularDetalle.marca} {celularDetalle.modelo}
            </h3>
            <div style={{ overflowY: 'auto', flex: 1, marginTop: 16 }}>
              {asignaciones.length === 0 ? (
                <p style={{ color: '#888' }}>Sin asignaciones registradas</p>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead style={{ position: 'sticky', top: 0 }}>
                    <tr style={{ background: '#1e6378', color: 'white' }}>
                      <th style={{ padding: 8, textAlign: 'left' }}>Usuario</th>
                      <th style={{ padding: 8, textAlign: 'left' }}>F. Inicio</th>
                      <th style={{ padding: 8, textAlign: 'left' }}>F. Fin</th>
                      <th style={{ padding: 8, textAlign: 'left' }}>Estado</th>
                      <th style={{ padding: 8, textAlign: 'left' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {asignaciones.map((a, i) => (
                      <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                        <td style={{ padding: 8 }}>{a.usuario_nombre}</td>
                        <td style={{ padding: 8 }}>{formatFecha(a.fecha_inicio)}</td>
                        <td style={{ padding: 8 }}>{formatFecha(a.fecha_fin)}</td>
                        <td style={{ padding: 8 }}>
                          <span style={{
                            padding: '3px 8px', borderRadius: 4, fontSize: 11,
                            color: 'white', background: coloresEstado[a.estado] ?? '#6c757d'
                          }}>
                            {a.estado}
                          </span>
                        </td>
                        <td style={{ padding: 8 }}>
                          <button className="btn-edit" onClick={() => handleDescargar(a)}>Descargar</button>
                          {a.estado === 'Pendiente' && (
                            <button className="btn-edit" style={{ background: '#28a745', color: 'white' }}
                              onClick={() => { setAsignSeleccionada(a); fileRef.current.click(); }}>
                              Subir firmada
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <input ref={fileRef} type="file" accept="application/pdf" style={{ display: 'none' }}
              onChange={(e) => {
                const archivo = e.target.files[0];
                if (archivo) handleSubirFirmada(archivo);
                e.target.value = '';
              }} />
            <div style={{ textAlign: 'right', marginTop: 16, flexShrink: 0 }}>
              <button className="btn-secondary" onClick={() => setCelularDetalle(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      <Modal modal={modal} setModal={setModal} />
    </div>
  );
}